export const LANGUAGE_CONFIG = {
    en: "English",
    mr: "Marathi"
};

export const INITIAL_TABLE_DATA = [];

export const COLUMNS_CONFIG = {
    en: {
        request_unique_id: { label: "Proposal ID" },
        applicantName: { label: "Applicant Name" },
        applicantMobile: { label: "Contact" },
        applicantEmail: { label: "Email" },
        applicantAddress: { label: "Address" },
        division: { label: "Division" },
        district: { label: "District" },
        taluka: { label: "Taluka" },
        village: { label: "City" },
        surveyNumber: { label: "CTS/Gat/Survey No." },
        satbaraAttachment: { label: "7/12 Extract" },
        meausurementAttachment: { label: "Measurement Sheet" },
        certificatename: { label: "Service Type" },
        feeReceipt: { label: "Payment" },
        feeReceiptdocument: { label: "Fee Recipt" },
        dateOfIssue: { label: "Submission Date", sortable: true },
        dateOfAction: { label: "Approval Date" },
        status: { label: "Status" },
        certificatePath: { label: "Document" },
        remark: { label: "Remark" },
        senderID: { label: "Applicant ID" }
    },
    mr: {
        request_unique_id: { label: "प्रस्ताव क्रमांक" },
        applicantName: { label: "अर्जदाराचे नाव" },
        applicantMobile: { label: "संपर्क" },
        applicantEmail: { label: "ईमेल" },
        applicantAddress: { label: "पत्ता" },
        division: { label: "विभाग" },
        district: { label: "जिल्हा" },
        taluka: { label: "तालुका" },
        village: { label: "शहर" },
        surveyNumber: { label: "सर्व्हे नंबर" },
        satbaraAttachment: { label: "७/१२ उतारा" },
        meausurementAttachment: { label: "मोजणी पत्रक" },
        certificatename: { label: "सेवा प्रकार" },
        feeReceipt: { label: "पेमेंट" },
        feeReceiptdocument: { label: "पेमेंट" },
        dateOfIssue: { label: "सबमिशन तारीख", sortable: true },
        dateOfAction: { label: "मंजुरी तारीख" },
        status: { label: "स्थिती" },
        certificatePath: { label: "दस्तऐवज" },
        remark: { label: "शेरा" },
        senderID: { label: "अर्जदार आयडी" }
    }
};

export const FILTER_OPTIONS = {
    en: {
        status: [
            { value: "pending", label: "Pending" },
            { value: "approved", label: "Approved" },
            { value: "rejected", label: "Reassigned" },
            { value: "sendforauthorization", label: "Send for Authorization" },
            { value: "sendbackforreview", label: "Send Back for Review" },
            { value: "sendforauthorizationmanully", label: "Send for Authorization2" },
            { value: "sendforauthorizationautomatically", label: "Send for Authorization1" },
            { value: "reassigned", label: "Reassigned" }
        ],
        date: [
            { value: "today", label: "Today" },
            { value: "yesterday", label: "Yesterday" },
            { value: "this_month", label: "This Month" }
        ],
        ServiceType: [
            { value: "zone", label: "Zone Certificate" },
            { value: "part_plan", label: "Part Plan" }
        ]
    },
    mr: {
        status: [
            { value: "pending", label: "प्रलंबित" },
            { value: "approved", label: "मंजूर" },
            { value: "rejected", label: "नाकारले" }
        ],
        date: [
            { value: "today", label: "आज" },
            { value: "yesterday", label: "काल" },
            { value: "this_month", label: "या महिन्यात" }
        ],
        ServiceType: [
            { value: "zone", label: "झोन प्रमाणपत्र" },
            { value: "part_plan", label: "भाग योजना प्रमाणपत्र" }
        ]
    }
};

export const UI_TEXT = {
    en: {
        searchPlaceholder: "Search by name, survey no, or phone...",
        noResultsTitle: "No request found for Part Plan/Zone Certificate.",
        noResultsDescription: (hasSearch) => hasSearch
            ? "Try adjusting your search or filter criteria"
            : "It looks like you haven't submitted any request for a Part Plan/Zone Certificate. Please submit a request to continue.",
        showAll: "Show All Applications",
        language: "Language",
        filter: "Filter",
        statusSummary: "Approved {approvedCount}/{totalCount}",
        columns: "Columns"
    },
    mr: {
        searchPlaceholder: "नाव, सर्व्हे नंबर किंवा फोन नंबर द्वारे शोधा...",
        noResultsTitle: "भाग योजना/झोन प्रमाणपत्रासाठी कोणतीही विनंती सापडली नाही.",
        noResultsDescription: (hasSearch) => hasSearch
            ? "आपली शोध किंवा फिल्टर निकष समायोजित करण्याचा प्रयत्न करा"
            : "असे दिसते की आपण भाग योजना/झोन प्रमाणपत्रासाठी कोणतीही विनंती सबमिट केलेली नाही. कृपया पुढे जाण्यासाठी विनंती सबमिट करा.",
        showAll: "सर्व अर्ज दाखवा",
        language: "भाषा",
        filter: "फिल्टर",
        statusSummary: "मंजूर {approvedCount}/{totalCount}",
        columns: "स्तंभ"
    }
};

export const DEFAULT_VISIBLE_COLUMNS = [
    'dateOfIssue', 'request_unique_id', 'surveyNumber',
    'satbaraAttachment', 'certificatename', 'status', 'certificatePath'
];